import Collapse from 'bootstrap/js/dist/collapse'
import Offcanvas from 'bootstrap/js/dist/offcanvas'
import Dropdown from 'bootstrap/js/dist/dropdown'

const NAVBAR_DESKTOP_MEDIA_QUERY = '(min-width: 992px)'

/**
 * Opens the main navbar's dropdown submenus on mouse hover while the
 * navbar is in its expanded (desktop) state, matching the
 * `navbar-expand-lg` breakpoint. Below that breakpoint the navbar
 * collapses into the offcanvas menu, where hover does not apply, so
 * the dropdowns keep their default Bootstrap click-to-toggle behaviour.
 *
 * @return {void}
 */
function enableNavbarHoverDropdowns() {
	const desktopMediaQuery = window.matchMedia(NAVBAR_DESKTOP_MEDIA_QUERY)
	const dropdowns = document.querySelectorAll('#main-nav .navbar-nav > .dropdown')

	dropdowns.forEach((dropdown) => {
		const toggle = dropdown.querySelector(':scope > .dropdown-toggle')

		if (!toggle) {
			return
		}

		dropdown.addEventListener('mouseenter', () => {
			if (desktopMediaQuery.matches) {
				Dropdown.getOrCreateInstance(toggle).show()
			}
		})

		dropdown.addEventListener('mouseleave', () => {
			if (desktopMediaQuery.matches) {
				Dropdown.getOrCreateInstance(toggle).hide()
			}
		})
	})
}

document.addEventListener('DOMContentLoaded', enableNavbarHoverDropdowns)

export {
	Collapse,
	Offcanvas,
	Dropdown
}
